import strFunc from "@/lib/lyg/string";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function TodoContentRow(props: any) {
  let myProps = {
    row_num: 0,
    todo_data: {},
    todo_data_arr: [],
    set_todo_data_arr: (inData: any) => { },
    delete_todo_content_row: (row_num: number) => { },
    open_select_cg_word_arr_popup: (inData: any) => { },
    ...props
  };
  let todo_data = myProps.todo_data;
  let select_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });
  let row_num = myProps.row_num;

  const handleInputChange = (e: any) => {
    let value = e.target.value;
    let name = e.target.name;

    if (name == "a_success_amount") {
      value = strFunc.uncomma(value);
    } else if (name == "a_success_amount_start") {
      value = strFunc.uncomma_int(value) - 1;
    }

    let change_todo_data_arr = [...myProps.todo_data_arr];
    let tmp_todo_data = { ...todo_data };
    tmp_todo_data[name] = value;

    if(name=="a_sort_det"){
      if(value=="cg_word_custom"){
        tmp_todo_data.cg_word_custom_arr = [];
        if(tmp_todo_data.cg_word_arr){
          tmp_todo_data.cg_word_custom_arr = [...tmp_todo_data.cg_word_arr];
        }
        tmp_todo_data.a_success_amount_start = 0;
        tmp_todo_data.a_success_amount = tmp_todo_data.cg_word_custom_arr.length;
      }
    }

    change_todo_data_arr[row_num] = tmp_todo_data;

    myProps.set_todo_data_arr(change_todo_data_arr);
  };

  let first_tr_style: any = {};
  first_tr_style.borderTop = "2px solid #7275ffff";

  return (
    <>
      <tr style={first_tr_style}>
        <th>
          {row_num + 1}.
        </th>
        <td colSpan={3}>
          <div className="my_flex_left">
            <select className="row-input" onChange={handleInputChange}
              style={{ width: 100 }}
              name="a_sort"
              value={todo_data.a_sort} >
              <option value={"homework"}>숙제</option>
              <option value={"study"}>학습</option>
            </select>
            <select className="row-input" onChange={handleInputChange}
              style={{ width: 100 }}
              name="a_sort_det"
              value={todo_data.a_sort_det}
            >
              <option value="">세부</option>
              <option value={"cg_word"}>전체단어</option>
              <option value={"cg_word_custom"}>선택단어</option>
            </select>

            {todo_data.a_sort_det == "cg_word" &&
              <>
                <span>시작:</span>
                <input type="text" className="row-input" onChange={handleInputChange}
                  name="a_success_amount_start"
                  value={strFunc.comma(todo_data.a_success_amount_start + 1)}
                  autoComplete="off"
                  style={{ width: 50, textAlign: "center" }} />
                <span>총량:</span>
                <input type="text" className="row-input" onChange={handleInputChange}
                  name="a_success_amount"
                  value={strFunc.comma(todo_data.a_success_amount)}
                  autoComplete="off"
                  style={{ width: 50, textAlign: "center" }} />
                <span style={{ color: "gray" }}>
                  분량: {strFunc.comma(todo_data.a_success_amount - todo_data.a_success_amount_start)}
                </span>
              </>
            }

            {todo_data.a_sort_det == "cg_word_custom" &&
            <>
              <span>총량:</span>
              <span>
                {strFunc.comma(todo_data.a_success_amount)}개
              </span>
              <button className="btn btn-dark" 
                onClick={() => {
                  myProps.open_select_cg_word_arr_popup({
                    row_num:row_num,
                    todo_data:todo_data
                  });
                }}
              >단어선택</button>
            </>
            }
          </div>
        </td>
      </tr>
      <tr>
        <th>제목</th>
        <td>
          <input type="text" className="row-input" onChange={handleInputChange}
            name="a_title"
            autoComplete="off"
            value={todo_data.a_title} />
        </td>
        <th>옵션</th>
        <td>
          <div style={{ position: "relative" }}>
            <select className="row-input ml-1" onChange={handleInputChange}
              name="a_amount_sort"
              value={todo_data.a_amount_sort}
              style={{ width: 60 }}>
              <option value="">기준</option>
              <option value="페이지">페이지</option>
              <option value="챕터">챕터</option>
              <option value="개">개</option>
              <option value="문제">문제</option>
              <option value="단원">단원</option>
            </select>
            <button className="btn btn-red ml-1"
              style={{ position: "absolute", right: 0 }}
              onClick={() => {
                myProps.delete_todo_content_row(row_num);
              }}
            >X</button>
          </div>
        </td>
      </tr>
    </>
  );
};
export default TodoContentRow;